import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
  },
  responseType: 'json',
  responseEncoding: 'utf8',
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Eğer baseURL '/api' ve endpoint '/api/...' ile başlıyorsa, öneki kaldır
    if (typeof config.url === 'string' && config.url.startsWith('/api/')) {
      config.url = config.url.replace(/^\/api\//, '/');
    }

    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Dil header'ını ekle
    const language = localStorage.getItem('language') || 'en';
    config.headers['x-language'] = language;
    
    // Entity ID header'ını ekle
    const entityId = localStorage.getItem('currentEntityId');
    if (entityId) {
      config.headers['x-entity-id'] = entityId;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export { api };
export default api;
